/**
 * Plugin to handle the header search
 */

(function($) {

  'use strict';

  var pluginName = 'trademarkHeaderSearch',
    namespace = 'plugin_' + pluginName;

  /**
   * The Plugin constructor
   */
  function Plugin(element) {
    this.headerSearch = $(element);
    this.header = $('.shopify-section__header');
    this.headerSearchForm = this.headerSearch.find('.header-search__form');
    this.headerInput = this.headerSearch.find('.header-search__input');
    this.headerSearchResults = this.headerSearch.find('.header-search__results-wrapper');
    this.submitBtn = this.headerSearchForm.find('.icon-search');
    //this.searchResultsTemplate = Template7.compile($('#search-results-template').html());
    this.searchResultsTemplate = $('#search-results-template').html();
    this.searchMode = 'product,article,page';
    this.body = $('body');
    this.pageOverlay = $('.page__overlay');

    this.sidebarNavInstance = $('.sidebar-nav').data('plugin_trademarkMobileSidebar');
    this.miniCartInstance = $('.mini-cart').data('plugin_trademarkMiniCart');

    $('[data-action="open-search"]').on('click', $.proxy(this._openSearch, this));
    $('[data-action="close-search"]').on('click', $.proxy(this._closeSearch, this));

    this.headerInput.on('keyup', $.proxy(this._initSearch, this));

    this.headerSearchForm.on('submit', $.proxy(this._formSubmitted, this));

    this.submitBtn.on('click',{triggerEl: this.headerSearchForm}, function(e) {
      e.data.triggerEl.trigger('submit');
    });
  }

  Plugin.prototype.destroy = function() {
    $('[data-action="open-search"]').off('click');
    $('[data-action="close-search"]').off('click');

    this.headerSearch.removeData('plugin_trademarkHeaderSearch');
    this.headerInput.off('keyup');
    this.headerSearchForm.off('submit');
    this.body.off('.trademarkHeaderSearch');
    this.pageOverlay.off('click');
  };

  Plugin.prototype._openSearch = function(event) {
    var self = this;

    // If either mobile sidebar or mini-cart are open we must first close them, otherwise we open directly
/*
    if (this.sidebarNavInstance.state === 'opening' || this.sidebarNavInstance.state === 'opened') {
      this.sidebarNavInstance._toggleSidebar(event);

      $(document).one('closed.trademarkMobileSidebar', function() {
        self._doOpenSearch();
      });
    } else if (undefined !== this.miniCartInstance && (this.miniCartInstance.state === 'opening' || this.miniCartInstance.state === 'opened')) {
      this.miniCartInstance._toggleMiniCart(event);

      $(document).one('closed.trademarkMiniCart', function() {
        self._doOpenSearch();
      });
    } else {
      this._doOpenSearch(); // Both are closed so we can open directly
    }
    */
    this._doOpenSearch();
    event.preventDefault();
  };

  Plugin.prototype._closeSearch = function(event) {
    this.body.removeClass('no-scroll');
    this.pageOverlay.removeClass('page__overlay--open');
    this.headerSearch.removeClass('header-search--open');
    this.header.removeClass('make-top');
    this.body.off('.trademarkHeaderSearch');

    event.preventDefault();
  };

  Plugin.prototype._doOpenSearch = function() {
    var self = this;
    console.log(this);
    this.body.addClass('no-scroll');
    this.pageOverlay.addClass('page__overlay--open');
    this.pageOverlay.on('click', $.proxy(this._closeSearch, this));

    this.headerSearch.addClass('header-search--open');
    this.header.addClass('make-top');
    this.headerSearch.one('transitionend', function() {
      self._cursorFocus(self.headerInput);
    });

    this.body.on('keyup.trademarkHeaderSearch', function(event) {
      if (event.keyCode == 27) {
        self._closeSearch(event);
      }
    });
/*
    this.body.on('click.trademarkHeaderSearch', function(outsideEvent) {
      if (!$(outsideEvent.target).closest('#shopify-section-header').length) {
        self._closeSearch(outsideEvent);
      }
    });*/
  };

  Plugin.prototype._initSearch = function(event) {
    var target = $(event.currentTarget);

    clearTimeout(target.data('timeout'));

    target.data('timeout', setTimeout($.proxy(this._doSearch, this), 250));
  };

  Plugin.prototype._doSearch = function(event) {
    // No autocompletion on mobile
    //if (Modernizr.mq('(max-width: 1079px)')) {
      //return;
    //}

    // If we are on mobile, we do a single search that will get all resources, based on the setting. If tablet and higher, we do two Ajax calls: one
    // that will fetch product only, and another one that will fetch anything else
    if (this.headerInput.val() === '') {
      this.headerSearchResults.empty();
      return; // No need to search if it's empty
    } else {
      this.headerSearchResults.html(_.template(this.searchResultsTemplate)({is_loading:true}));
    }

    if (this.searchMode === 'product') {
      this._doCompleteSearch();
    } else {
      this._doSeparateSearch();
    }
  };

  Plugin.prototype._doCompleteSearch = function(event) {
    var self = this;
    $.ajax({
      method: 'GET',
      url: '/search?view=json',
      dataType: 'json',
      data: {
        q: this.headerInput.val() + '*',
        type: this.searchMode
      }
    }).then(function(data) {
      self.headerSearchResults.html(_.template(self.searchResultsTemplate)({
        is_loading: false,
        split_search: false,
        results: data['results'],
        has_products_results: (data['results'].length > 0),
        results_count: data['results_count'],
        results_label: data['results_label'],
        results_url: (data['url'] + '&type=' + self.searchMode)
      }));

      //Currency.convertAll(window.theme['shopCurrency'], null, self.headerSearchResults.find('[data-money-convertible]'));

    });
  };

  Plugin.prototype._doSeparateSearch = function(event) {
    //console.log('seperate search');
    var searchTypes = this.searchMode.split(','),
      self = this;
      dataLayer.push({'search': this.headerInput.val()});
    var productSearch = $.ajax({
      method: 'GET',
      url: '/search?view=json',
      dataType: 'json',
      data: {
        q: this.headerInput.val() + '*',
        type: searchTypes[0]
      }
    });

    var articleSearch = $.ajax({
      method: 'GET',
      url: '/search?view=json',
      dataType: 'json',
      data: {
        q: this.headerInput.val() + '*',
        type: searchTypes.slice(1).join(',')
      }
    });

    var pageSearch = $.ajax({
      method: 'GET',
      url: '/search?view=json',
      dataType: 'json',
      data: {
        q: this.headerInput.val() + '*',
        type: 'page'
      }
    });

//on_sale_label: window.languages.productLabelsOnSale,
    $.when(productSearch, articleSearch,pageSearch).then(function(data1, data2, data3) {
      self.headerSearchResults.html(_.template(self.searchResultsTemplate)({
        is_loading: false,
        split_search: true,
        has_products_results: (data1[0]['results'].length > 0),
        has_article_results: (data2[0]['results'].length > 0),
        has_page_results: (data3[0]['results'].length > 0),
        products: {
          results: data1[0]['results'],
          results_count: data1[0]['results_count'],
          results_label: data1[0]['results_label'],
          results_url: (data1[0]['url'] + '&type=' + searchTypes[0])
        },
        articles: {
          results: data2[0]['results'],
          results_count: data2[0]['results_count'],
          results_label: data2[0]['results_label'],
          results_url: (data2[0]['url'] + '&type=' + searchTypes.slice(1).join(','))
        },
        pages: {
          results: data3[0]['results'],
          results_count: data3[0]['results_count'],
          results_label: data3[0]['results_label'],
          results_url: (data3[0]['url'] + '&type=' + searchTypes.slice(1).join(','))
        }
      }));
      // BOLD Code for CSP search integration
      for (var i=0; i< data1[0]['results'].length; i++){
        var tempProduct = data1[0]['results'][i];
        BOLD.pre.addProductJson({id: tempProduct.id, variants: tempProduct.variants});
      }
      // BOLD: CSP
         //console.log("update prices with new mark up");
      //Currency.convertAll(window.theme['shopCurrency'], null, self.headerSearchResults.find('[data-money-convertible]'));
    });
  };

  Plugin.prototype._formSubmitted = function(event) {
    this.headerInput.val(this.headerInput.val() + '*');
    return true;
  };

  /**
   * Allow to give focus on an item while preserving scroll position
   */
  Plugin.prototype._cursorFocus = function(element) {
    var x = window.scrollX,
      y = window.scrollY;

    element.focus();
    window.scrollTo(x, y);
  };

  $.fn[pluginName] = function(options) {
    var method = false,
      methodArgs = arguments;

    if (typeof options == 'string') {
      method = options;
    }

    return this.each(function() {
      var plugin = $.data(this, namespace);

      if (!plugin && !method) {
        $.data(this, namespace, new Plugin(this, options));
      } else if (method) {
        callMethod(plugin, method, Array.prototype.slice.call(methodArgs, 1));
      }
    });
  };
}(jQuery));
//end search plugin


/**
 * Plugin to handle product update
 */

(function ($) {

  'use strict';

  var pluginName = 'trademarkProduct',
    namespace = 'plugin_' + pluginName;

  /**
   * The Plugin constructor
   * @constructor
   * @param {HTMLElement} element The element that will be monitored
   * @param {Object} options
   */
  function Plugin(element, options) {
    this.element = $(element);

    this._init(options);
  }

  Plugin.prototype._init = function(options) {
    this.product = options['product'];
    this.productID = options['productID'];
    this.enableHistoryState = options['enableHistoryState'];
    this.optionsWithValues = options['optionsWithValues'];
    this.defaultVariant = options['defaultVariant'];
    this.allowSelectingSoldOutVariants = options['allowSelectingSoldOutVariants'];
    this.context = options['context'] || null;
    this.singleOptionSelectors = this.element.find('.single-option-selector');
    this.variant_buttons = this.element.find('.btn-variant');
    this.variant_switch = this.element.find('.switch-variant input');
    this.stickyDropdown = $('#sticky-dropdown-variant');
    this.dataSelectors = this.element.find('[data-selector-type]').toArray();
    this.masterSelector = this.element.find('#product-select-' + options['product']['id']);
    this.productSlides = this.element.find('.product-slide');
    this.ogComparePrice = this.element.find('fs-compare-price');
    //this.productThumbs = this.element.find('.variant-thumb');
    this.productPrices = this.element.find('.product__prices');
    if(options['addToCartBtnOverride'] != undefined){
      this.addToCartButton = this.element.find(options['addToCartBtnOverride']);
    }else{
      this.addToCartButton = this.element.find('.product__add-to-cart');
    }

    this.quantitySelector = this.element.find('.quantity-control');

    this.currentVariant = this._getVariantFromOptions();

    if(this.currentVariant['compare_at_price'] > 100){
        this.ogComparePrice.html(Shopify.formatMoney(this.currentVariant['compare_at_price'], window.theme.moneyFormat));
        this.ogComparePrice.removeClass('d-none');
    }else{
      this.ogComparePrice.addClass('d-none');
    }

    this.singleOptionSelectors.on('change', $.proxy(this._onSelectorChanged, this));
    this.quantitySelector.find('[data-action="decrease-product-quantity"]').on('click', $.proxy(this._decreaseProductQuantity, this));
    this.quantitySelector.find('[data-action="increase-product-quantity"]').on('click', $.proxy(this._increaseProductQuantity, this));

    this.variant_buttons.on('click',{plg: this.element}, function(e) {
      if(!$(this).hasClass('disabled'))
      {
        let elSel = $(this).data('selector');
        let opVal = $(this).data('value');
        //e.data.plg.find('.btn-variant').removeClass('active');
        $(this).parent().find('.btn-variant').removeClass('active');
        $(this).addClass('active');


        e.data.plg.find('#'+elSel+' option[value="'+opVal+'"]').prop('selected', true);
        $('#'+elSel).trigger('change');
      }
    });

    this.variant_switch.on('change',{plg: this.element}, function(e) {
      let elSel = $(this).data('selector');
      let isChecked = $(this).is(":checked");

      e.data.plg.find('#'+elSel+' option').prop('selected', false);
      if(isChecked){
        e.data.plg.find('#'+elSel+' option:nth-child(2)').prop('selected', true);
      }else{
        e.data.plg.find('#'+elSel+' option:nth-child(1)').prop('selected', true);
      }
      $('#'+elSel).trigger('change');
    });

    this.stickyDropdown.parent().find('.btn-variant').on('click',{plg: this.element,stydd: this.stickyDropdown}, function(e) {
      let opVal = $(this).data('value');
      e.data.plg.find('.btn-variant[data-value="'+opVal+'"]').trigger('click');
      e.data.stydd.parent().toggleClass('active');
      e.data.stydd.parent().find('.btn-variant').removeClass('active');
      $(this).addClass('active');
    });

    // In order to improve accessibility in keyboard, we allow to update swatches when pressing the Enter key over a label
    this.singleOptionSelectors.next('label').on('keypress', function(e) {
      if ((e.keyCode ? e.keyCode : e.which) == 13) {
        $(this).trigger('click');
      }
    });

    // If Ajax cart is enabled we add some more listeners to add product in the background
    this.addToCartButton.on('click', $.proxy(this._addToCart, this));
    $('[data-toggle="tooltip"]').tooltip();

    //force click btn of default variant to make sure only available options are active
    //$('.btn-variant[data-value="'+this.defaultVariant+'"]').trigger('click');
    this._updateSelectors([], this.currentVariant );
     //console.log(this.currentVariant);

  };

  Plugin.prototype.destroy = function() {
    this.singleOptionSelectors.off('change');
    this.singleOptionSelectors.next('label').off('keypress');
    this.addToCartButton.off('click');
    this.quantitySelector.find('[data-action="decrease-product-quantity"]').off('click');
    this.quantitySelector.find('[data-action="increase-product-quantity"]').off('click');

    this.element.removeData('plugin_trademarkProduct');
  };

  /**
   * ---------------------------------------------------------------------------------------------------
   * CODE THAT HANDLE PRODUCT OPERATIONS
   * ---------------------------------------------------------------------------------------------------
   */

  Plugin.prototype._decreaseProductQuantity = function(event) {
    var currentQuantity = this.quantitySelector.find('.quantity-selector__current-quantity'),
      currentQuantityAsNumber = parseInt(currentQuantity.val());

    // Do nothing if it's already one...
    if (currentQuantityAsNumber === 1) {
      event.preventDefault();
      return;
    }

    var newQuantity = currentQuantityAsNumber - 1;

    currentQuantity.text(newQuantity);

    this.quantitySelector.find('[name="quantity"]').val(newQuantity);
    //this._updatePricesOgWidget(false);
    event.preventDefault();
  };

  Plugin.prototype._increaseProductQuantity = function(event) {
    var currentQuantity = this.quantitySelector.find('.quantity-selector__current-quantity'),
      currentQuantityAsNumber = parseInt(currentQuantity.val()),
      newQuantity = currentQuantityAsNumber + 1;

    currentQuantity.text(newQuantity);

    this.quantitySelector.find('[name="quantity"]').val(newQuantity);
    //this._updatePricesOgWidget(false);
    event.preventDefault();
  };

  /**
   * ---------------------------------------------------------------------------------------------------
   * CODE THAT HANDLE VARIANT CHANGES IN THE FRONT
   * ---------------------------------------------------------------------------------------------------
   */

  /**
   * Whenever the variant changes, we have several things to update: the slideshow image, the prices,
   * the labels...
   */
  Plugin.prototype._onVariantChanged = function(previousVariant, newVariant) {
    // 1st: the slideshow
    this._updateSlideshowImage(previousVariant, newVariant);

    // 2st: the prices
    this._updateProductPrices(previousVariant, newVariant);

    // 3rd: update the variant dropdowns
    this._updateSelectors(previousVariant, newVariant);

    // 4th: the add to cart button
    this._updateAddToCartButton(previousVariant, newVariant);
  };

  /**
   * Switch to the correct slideshow image
   */
  Plugin.prototype._updateSlideshowImage = function(previousVariant, newVariant) {
    if (!newVariant || !newVariant['featured_image']) {
      return;
    }
/*
    if (this.productSlides.length > 0) {
      this.productSlides.slick(
        'slickGoTo',
        parseInt(this.productSlides.find('[data-image-id="' + newVariant['featured_image']['id'] + '"]').attr('data-image-position'))
      );
    }
*/
    //let filtername =  newVariant['public_title'].toLowerCase().replace(" ", "-");
    let vOptions = newVariant['public_title'].split("/");
    let filtername = vOptions[0].trim().toLowerCase().replace(" ", "-");
    //console.log(filtername);
    /*
    //not needed if using slick js for carosel
    if (this.productSlides.length > 0) {
      this.productSlides.each(function(){
        $(this).addClass('d-none');
        if($(this).find('img').attr("alt") == filtername || $(this).find('img').attr("alt") == 'all' ){
          $(this).removeClass('d-none');
        }
      });
    }
    */
    if(filtername != '' && filtername != 'standard' && filtername != 'reduce'){
      if ($('.pdp-content-nav').length > 0){
        $('.pdp-content-nav').find('.product-sticky__image').each(function(){
          $(this).addClass('d-none');
          if($(this).attr("alt") == filtername ){
            $(this).removeClass('d-none');
          }
        });
      }

      if (this.element.hasClass('product-item')){
        if (this.element.find('.product-item__image').length > 1){
          this.element.find('.product-item__image').each(function(){
            $(this).addClass('d-none');
            if($(this).attr("alt") == filtername ){
              $(this).removeClass('d-none');
            }
          });
        }
      }
    }

    if (this.context === 'homepage') {
      this.element.find('.product__featured-image[data-image-id="' + newVariant['featured_image']['id'] + '"]').show()
        .siblings().hide();
    }
  };

  /**
   * Update the prices. If the variant does not exist, we hide the prices completely
   */
  Plugin.prototype._updateProductPrices = function(previousVariant, newVariant) {
    if (!newVariant) {
      this.productPrices.each(function(index, element) {
        var parent = $(element).parent();

        if (parent.hasClass('form__control')) {
          parent.hide();
        } else {
          $(element).hide();
        }
      });
    } else {
      if (previousVariant && (previousVariant['price'] === newVariant['price']) && (previousVariant['compare_at_price'] === newVariant['compare_at_price'])) {
        return;
      }

      this.productPrices.empty();

      if (newVariant['compare_at_price'] > newVariant['price']) {
        this.productPrices.append('<span class="product__price product__price--new" data-money-convertible>' + Shopify.formatMoney(newVariant['price'], window.theme.moneyFormat) + '</span>');
        this.productPrices.append('<span class="product__price product__price--old" data-money-convertible>' + Shopify.formatMoney(newVariant['compare_at_price'], window.theme.moneyFormat) + '</span>');
        if(newVariant['compare_at_price'] > 100){
            this.ogComparePrice.html(Shopify.formatMoney((newVariant['compare_at_price']), window.theme.moneyFormat));
            this.ogComparePrice.removeClass('d-none');
        }else{
          this.ogComparePrice.addClass('d-none');
        }
      } else {
        //console.log("price append");
        this.productPrices.append('<span class="product__price" data-money-convertible>' + Shopify.formatMoney(newVariant['price'], window.theme.moneyFormatNoZero) + '</span>');
      }

      this.productPrices.show().parent().show();
    }

  };

  Plugin.prototype._updatePricesOgWidget = function() {
    const currentQuantity = this.quantitySelector.find('.quantity-selector__current-quantity').val();

    $('og-price').each(function(){
      let priceString = this.shadowRoot.innerHTML;
      const regex = /\$([0-9]+\.[0-9]+)/;
      const match = priceString.match(regex);
      if (match) {
          let floatAmount = parseFloat(match[1]);
          
          if($(this).data('org-price') == undefined || $(this).data('org-price') === 0){
            $(this).data('org-price',floatAmount);
          }else{
            floatAmount = $(this).data('org-price');
          }

          const newAmmountValue = floatAmount*currentQuantity;
          this.shadowRoot.innerHTML = "$"+newAmmountValue+".00";
      } else {
        
          let floatAmount = $(this).data('org-price');
          let newAmmountValue = floatAmount*currentQuantity;
          this.shadowRoot.innerHTML = "$"+newAmmountValue+".00";
      }
    });

    //for non og-widget
    $('.product__form .product-item__price--new').each(function(){
      let priceString = $(this).html();
     
      const regex = /\$([0-9]+\.[0-9]+)/;
      const match = priceString.match(regex);
      if (match) {
         let floatAmount = parseFloat(match[1]);
          if($(this).data('org-price') == undefined || $(this).data('org-price') === 0){
            $(this).data('org-price',floatAmount);
          }else{
            floatAmount = $(this).data('org-price');
          }

          const newAmmountValue = floatAmount*currentQuantity;
          $(this).html( "$"+newAmmountValue+".00");
      }

    });

  };


  Plugin.prototype._updatePackagingToggle = function(isAvailable) {

    if (isAvailable) {
      $('.switch-variant input[name="packaging"]').removeAttr('disabled');
    } else {
      $('.switch-variant input[name="packaging"]').attr('disabled', 'disabled');
    }
  }

  Plugin.prototype._updateVariantBtn = function(isAvailable, value) {

    if (isAvailable) {
      $('.btn-variant[data-value="'+value+'"]').removeClass('disabled');
    } else {
      $('.btn-variant[data-value="'+value+'"]').addClass('disabled');
    }
  }

  /**
   * Update the selectors
   *
   * We have different kind of selectors: the size one, the color swatch and standard dropdown. When a new variant is selected, we must check the options
   * and prevent selection of unavailable and, if selected by the merchant, sold out variants
   */
  Plugin.prototype._updateSelectors = function(previousVariant, newVariant) {
    // No need to recompute the combinations if there is only one option
    if (!newVariant || this.product['options'].length <= 1) {
      return;
    }

    var option1 = newVariant['option1'],
      option2 = newVariant['option2'],
      option3 = newVariant['option3'],
      variantsCount = this.product['variants'].length;

    for (var i = 0 ; i != this.dataSelectors.length ; ++i) {
      var dataSelector = $(this.dataSelectors[i]),
        dataSelectorType = dataSelector.attr('data-selector-type'),
        optionIndex = (i + 1),
        optionValues = this.optionsWithValues[i]['values'];

      for (var j = 0 ; j != optionValues.length ; ++j) {
        var valueToCheck = optionValues[j],
          variantExists = false,
          allowVariantSelection = false,
          variantAvailable = false;

        if (optionIndex === 1) {
          for (var k = 0 ; k != variantsCount ; ++k) {
            var currentVariant = this.product['variants'][k];

            if (currentVariant['option1'] === valueToCheck && currentVariant['option2'] === option2 && currentVariant['option3'] === option3) {
              variantExists = true;
              variantAvailable = currentVariant['available'];

              break;
            }
          }
        } else if (optionIndex === 2) {
          for (var k = 0 ; k != variantsCount ; ++k) {
            var currentVariant = this.product['variants'][k];

            if (currentVariant['option1'] === option1 && currentVariant['option2'] === valueToCheck && currentVariant['option3'] === option3) {
              variantExists = true;
              variantAvailable = currentVariant['available'];

              break;
            }
          }
        } else if (optionIndex === 3) {
          for (var k = 0 ; k != variantsCount ; ++k) {
            var currentVariant = this.product['variants'][k];

            if (currentVariant['option1'] === option1 && currentVariant['option2'] === option2 && currentVariant['option3'] === valueToCheck) {
              variantExists = true;
              variantAvailable = currentVariant['available'];

              break;
            }
          }
        }

        if (variantExists) {
          if (variantAvailable || this.allowSelectingSoldOutVariants) {
            allowVariantSelection = true;
          }
        } else {
          allowVariantSelection = false;
        }

        if (dataSelectorType === 'size') {
          // For the size, we need to add the "product__size--unavailable" class and "disabled" to the input
          var sizeItem = dataSelector.find('.product__size').eq(j);

          if (allowVariantSelection) {
            sizeItem.removeClass('product__size--unavailable').find('> input').removeAttr('disabled')
              .next('label').attr('tabindex', 0);
          } else {
            sizeItem.addClass('product__size--unavailable').find('> input').attr('disabled', 'disabled')
              .next('label').removeAttr('tabindex');
          }

        } else if (dataSelectorType === 'color') {
          // For the color, we need to add the "product__color--unavailable" class and "disabled" to the input
          var colorItem = dataSelector.find('.product__color').eq(j);

          if (allowVariantSelection) {
            colorItem.removeClass('product__color--unavailable').find('> input').removeAttr('disabled')
              .next('label').attr('tabindex', 0);
          } else {
            colorItem.addClass('product__color--unavailable').find('> input').attr('disabled', 'disabled')
              .next('label').removeAttr('tabindex');
          }
        } else if (dataSelectorType === 'select') {
          // For the select, we need to add disabled to the option
          var optionItem = dataSelector.find('option').eq(j);

          if (allowVariantSelection) {
            optionItem.removeAttr('disabled');
          } else {
            optionItem.attr('disabled', 'disabled');
          }
          this._updatePackagingToggle(allowVariantSelection);
          this._updateVariantBtn(allowVariantSelection,valueToCheck);
        }
      }
    }
  };

  /**
   * Update the add to cart button
   */
  Plugin.prototype._updateAddToCartButton = function(previousVariant, newVariant) {
    // Check if we have payment button
    var smartPaymentButton = this.element.find('.shopify-payment-button');
//console.log(newVariant);
    if (!newVariant) {
      this.addToCartButton.attr('disabled', 'disabled')
        .removeClass('btn-primary')
        .addClass('btn-secondary')
        .text(window.languages.productFormUnavailable);
        this.addToCartButton.show();
        this.element.find('a.button').hide();
      smartPaymentButton.hide();
    } else {
      if (newVariant['available']) {
        this.addToCartButton.removeAttr('disabled')
          .removeClass('klaviyo-bis-trigger')
          .text(window.languages.productFormAddToCart);
          this.addToCartButton.show();
          this.element.find('a.button').hide();

        smartPaymentButton.show();
      } else {
        this.addToCartButton.addClass('klaviyo-bis-trigger')
          .text(window.languages.productFormSoldOut);
          //        .attr('data-disable-recharge','true')

        if (this.element.hasClass('product-item')){
          this.addToCartButton.hide();

          var newHref = this.element.data('href')+'?variant='+newVariant['id'];
          this.element.find('a.btn').attr('href', newHref);
          this.element.find('a.btn').show();
        }
        smartPaymentButton.hide();
      }
    }
    if (this.element.hasClass('product-item')){
      var newHref = this.element.data('href')+'?variant='+newVariant['id'];
      this.element.find('a.product-item__link ,a.link').attr('href', newHref);
    }
  };

  /**
   * ---------------------------------------------------------------------------------------------------
   * INTERNAL CODE THAT HANDLE VARIANT CHANGES
   * ---------------------------------------------------------------------------------------------------
   */

  /**
   * This call back is called whenever a property in one of the select or radio button has changed
   */
  Plugin.prototype._onSelectorChanged = function() {
    var previousVariant = this.currentVariant;
    this.currentVariant = this._getVariantFromOptions();
    this._onVariantChanged(previousVariant, this.currentVariant);

    if (this.currentVariant) {
      if (this.enableHistoryState) {
        this._updateHistoryState(this.currentVariant);
      }

      // We need to modify the hidden select that contain the id attribute as well
      this.masterSelector.find('[selected]').removeAttr('selected');
      this.masterSelector.find('[value="' + this.currentVariant['id'] + '"]').prop('selected', true);
      this.masterSelector.attr('og-product',this.currentVariant['id']);

      // We also trigger an event so that other system can hookup and perform additional changes
      $(document).trigger('variant_changed.product', this.currentVariant);
    }



  };

  /**
   * Update the HTML history state
   */
  Plugin.prototype._updateHistoryState = function(variant) {
    if (!history.replaceState) {
      return;
    }

    var newUrl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
    window.history.replaceState({path: newUrl}, '', newUrl);
  };

  /**
   * Get the variant that is currently selected
   */
  Plugin.prototype._getVariantFromOptions = function() {
    var selectedValues = this._getCurrentOptions();
    var variants = this.product['variants'];
    var found = false;
    variants.forEach(function(variant) {
      var satisfied = true;

      selectedValues.forEach(function(option) {
        if (satisfied) {
          satisfied = (option.value === variant[option.index]);
        }
      });

      if (satisfied) {
        found = variant;
      }
    });

    return found || null;
  };

  /**
   * Extract all the current options
   */
  Plugin.prototype._getCurrentOptions = function() {

    var currentOptions = this.singleOptionSelectors.toArray().map(function(element) {
      var $element = $(element),
        type = $element.attr('type'),
        index = $element.attr('data-option-index');

      if (type === 'radio' || type === 'checkbox') {
        if ($element[0].checked) {
          return {value: $element.val(), index: index};
        } else {
          return false;
        }
      } else {

        return {value: $element.val(), index: index};
      }
    });

    // remove any unchecked input values if using radio buttons or checkboxes

    return currentOptions.filter(function(item) {
      return item;
    });
  };

  /**
   * ---------------------------------------------------------------------------------------------------
   * INTERNAL CODE THAT HANDLE PRODUCT ADD TO CART
   * ---------------------------------------------------------------------------------------------------
   */

  Plugin.prototype._addToCart = function(event) {
    var self = this;
    var itemId = this.element.find('[name="id"]').val();
    var formData = this.element.find('#product_form_'+this.productID+'[action^="/cart/add"]').serialize()
    //console.log(this.element.find('#product_form_'+this.productID+'[action^="/cart/add"]').serialize());
    //console.log(formData);
    if(!this.addToCartButton.hasClass('klaviyo-bis-trigger'))
    {
      // First, we switch the status of the button to display the spinner
      this.addToCartButton.attr('disabled', 'disabled').addClass('btn-loading');
      // Then we add the product in Ajax
      $.ajax({
        method: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data: formData
      }).then(function() {
        $.ajax({
          method: 'GET',
          url: '/cart.js',
          dataType: 'json'
        }).then(function(cart) {
          // Last parameter set to true allow to indicate the cart to force open the mini-cart)
          $(document).trigger('theme:cart:updated', [cart, true, true, itemId]);
          self.addToCartButton.removeAttr('disabled').removeClass('btn-loading');
        });
      }).catch(function(error) {
        // If there is an error while adding (usually if all products are added to the cart), we temporarily
        // display the message from Shopify, and then revert to the original message after 2 seconds
        var errorMessage = error.responseJSON['description'];

        self.addToCartButton.text(errorMessage)
          .removeAttr('disabled')
          .removeClass('btn-loading');

        setTimeout(function() {
          self.addToCartButton.text(window.languages.productFormAddToCart);
        }, 2500); 
      });
    }


    event.preventDefault();
  };

  $.fn[pluginName] = function(options) {
    var method = false,
      methodArgs = arguments;

    if (typeof options == 'string') {
      method = options;
    }

    return this.each(function() {
      var plugin = $.data(this, namespace);

      if (!plugin && !method) {
        $.data(this, namespace, new Plugin(this, options));
      } else if (method) {
        callMethod(plugin, method, Array.prototype.slice.call(methodArgs, 1));
      }
    });
  };
}(jQuery));
//end product plugin

/**
 * Plugin to handle the mini-cart
 */

(function ($) {

  'use strict';

  var pluginName = 'trademarkMiniCart',
    namespace = 'plugin_' + pluginName;

  /**
   * The Plugin constructor
   */
  function Plugin(element) {
    this.miniCart = $(element);
    this.announcementBar = $('.announcement-bar');
    this.header = $('.shopify-section__header');
    this.headerCartCount = $('.shopify-section__header .cart-count');
    this.sidebarNav = $('.sidebar-nav');

    this.state = 'closed';

    this.body = $('body');
    this.pageOverlay = $('.page__overlay');

    if (Modernizr.mq('(min-width: 1080px)')) {
      this.body.on('mouseenter keypress', '[data-action="toggle-mini-cart"]', $.proxy(this._toggleMiniCart, this));
    }
    //this.miniCart.on('click', '[data-action="remove-line-item"]', $.proxy(this._removeLine, this));

    $(document).on('theme:cart:updated', $.proxy(this._cartUpdated, this));
    $(window).on('resize.trademarkMiniCart', $.proxy(this._computeMiniCartHeight, this));

    // We automatically re-render it a first time to solve a strange issue where adding a product in Ajax, going to Checkout and go back does not re-render
    // the very last version in Liquid
    this._rerender(null);

    if (Modernizr.csstransitions) {
      this.miniCart.on('transitionend', $.proxy(this._emitTransitionEvent, this));
    }

  }

  Plugin.prototype.destroy = function() {
    this.miniCart.removeData('plugin_trademarkMiniCart');
    this.miniCart.find('[data-action="remove-line-item"]').off('click');
    this.body.off('.trademarkMiniCart');

    $(document).off('theme:cart:updated');
    $(window).off('.trademarkMiniCart');
  };

  Plugin.prototype.getState = function() {
    return this.state;
  };

  Plugin.prototype._toggleMiniCart = function(event) {
    var self = this;
    // The mini-cart can be toggled using "Enter" key in keyboard as well
    if ((event.keyCode ? event.keyCode : event.which) == 13) {
      event.preventDefault(); // Prevent to follow the link
    }

    if(event.type == "mouseover" || event.type == "mouseenter"){
      self.miniCart.removeClass('new-product');
    }

    this._computeMiniCartHeight();

    this.miniCart.toggleClass('mini-cart--open');
    this.header.toggleClass('make-top');

    if (this.miniCart.hasClass('mini-cart--open')) {
      // Before opening, we must check if the nav sidebar is open. If that's the case we first close it
/*
      var sidebarNavInstance = this.sidebarNav.data('plugin_trademarkMobileSidebar');

      if (sidebarNavInstance.state === 'opening' || sidebarNavInstance.state === 'opened') {
        sidebarNavInstance._toggleSidebar(event);
      }
*/
      this.state = 'opening';
      $(document).trigger('opening.trademarkMiniCart');

      //this.body.addClass('no-scroll');
      //this.pageOverlay.addClass('page__overlay--open');

      if (!Modernizr.csstransitions) {
        this.state = 'opened';
        $(document).trigger('opened.trademarkMiniCart');
      }

      this.miniCart.one('transitionend', function() {
        self.miniCart.focus(); // Allows to give focus for better accessibility on keyboard
      });


        this.miniCart.on('mouseleave', function(outsideEvent) {
           self._toggleMiniCart(outsideEvent);
        });


      this.body.on('keyup.trademarkMiniCart', function(outsideEvent) {
        if (outsideEvent.keyCode == 27) {
          self._toggleMiniCart(outsideEvent);
        }
      });
/*
      this.body.on('click.trademarkMiniCart', function(outsideEvent) {
        if (!$(outsideEvent.target).closest('#shopify-section-header').length) {
          self._toggleMiniCart(outsideEvent);
        }
      });
*/
    } else {
      this.state = 'closing';
      $(document).trigger('closing.trademarkMiniCart');

      //this.body.removeClass('no-scroll');
      this.body.off('.trademarkMiniCart');
      //this.pageOverlay.removeClass('page__overlay--open');

      this.miniCart.off('mouseleave');

      if (!Modernizr.csstransitions) {
        this.state = 'closed';
        $(document).trigger('closed.trademarkMiniCart');
      }
    }

    event.preventDefault();
  };

  Plugin.prototype._cartUpdated = function(event, cart, forceOpening, rerender, newItem) {
    // Bold:PRE
    if (typeof window.BOLD !== 'undefined'
       && typeof window.BOLD.common !== 'undefined'
       && typeof window.BOLD.common.cartDoctor !== 'undefined') {
       // NOTE: "cart" should be the variable containing the cart JSON data
       //console.log('running on cart page');
       cart = window.BOLD.common.cartDoctor.fix(cart);
    }
    // Bold:PRE
    this.headerCartCount.text(cart['item_count']);
    this.headerCartCount.parent().addClass('has-items');

    if (rerender || cart['item_count'] === 0) {
      if(newItem != null){
        this.miniCart.addClass('new-product');
      }

      this._rerender(newItem);
    } else {
      // If we do not completely re-render (for instance when we just delete a line), we just update the price
      this.miniCart.find('.mini-cart__total-price').replaceWith(
        '<span class="mini-cart-item__price mini-cart__total-price" data-money-convertible>' + Shopify.formatMoney(cart['total_price'], window.theme.moneyFormat) + '</span>'
      );
    }

    if (forceOpening) {
      this._toggleMiniCart(event);
    }

  };

  Plugin.prototype._removeLine = function(event) {
    var target = $(event.currentTarget),
      variantId = target.attr('data-variant-id'),
      lineItem = target.closest('.mini-cart__item-wrapper'),
      items = target.closest('.mini-cart__items');

    items.addClass('mini-cart__items--loading');

    $.ajax({
      method: 'POST',
      url: '/cart/change.js',
      dataType: 'json',
      data: {
        quantity: 0,
        id: variantId
      }
    }).then(function(newCart) {
      items.removeClass('mini-cart__items--loading');
      lineItem.slideUp(250, function() {$(this).remove();});

      $(document).trigger('theme:cart:updated', [newCart, false, false]);
    });

    event.preventDefault();
  };

  /**
   * Rerender each items of the mini cart
   *
   * @param cart
   * @private
   */
  Plugin.prototype._rerender = function(itemId) {
    // We render the alternate mini-cart template instead of rendering it in JavaScript. This allows app vendor to hook their own logic within the
    // mini-cart in pure Liquid
    var self = this;
    var newItemHtml

    $.ajax('/cart?view=mini-cart').then(function(result) {
      var domResult = $(result),
        miniCartCount = domResult.attr('data-cart-item-count');

        if(itemId != null){
          newItemHtml = $(result).find('[data-itemid="'+itemId+'"]');
          domResult.find('#newly-added-item').html(newItemHtml);

          //auto hide
          setTimeout(function () {
            self.miniCart.trigger('mouseleave');
          }, 3000);
        }

      self.miniCart.find('.mini-cart__inner').replaceWith(domResult.find('.mini-cart__inner'));

      self.headerCartCount.text(miniCartCount);
      self._computeMiniCartHeight();

      // Bold:PRE
      if (window.BOLD && BOLD.common && BOLD.common.eventEmitter &&
         typeof BOLD.common.eventEmitter.emit === 'function'){
      BOLD.common.eventEmitter.emit('BOLD_COMMON_cart_loaded');
      }
      // Bold:PRE


    });
  };

  /**
   * Compute the correct mini-cart height (by taking into account things such as top bar, viewport...)
   */
  Plugin.prototype._computeMiniCartHeight = function() {
    // First, we need to get how much of the "top bar" (which is not fixed) is visible in the viewport
    var announcementBarVisibleHeight = 0,
      headerOuterHeight = this.header.outerHeight();

    if (this.announcementBar.length > 0) {
      var announcementBarHeight = this.announcementBar.height(),
        windowHeight = $(window).height(),
        rect = this.announcementBar[0].getBoundingClientRect();

      announcementBarVisibleHeight = Math.max(0, rect.top > 0 ? Math.min(announcementBarHeight, windowHeight - rect.top) : (rect.bottom < windowHeight ? rect.bottom : windowHeight));
    }

    this.miniCart.find('.mini-cart__inner').css('max-height', (window.innerHeight - headerOuterHeight - announcementBarVisibleHeight) + 'px');
  };

  /**
   * Callback called whenever the transition (animation of opening or closing) is ended so we can emit events for other parts of the system
   */
  Plugin.prototype._emitTransitionEvent = function(event) {
    if (event.originalEvent.propertyName !== 'transform') {
      return;
    }

    if (this.state === 'opening' || this.state === 'opened') {
      this.state = 'opened';
      $(document).trigger('opened.trademarkMiniCart');
    } else {
      this.state = 'closed';
      $(document).trigger('closed.trademarkMiniCart');
    }
  };

  $.fn[pluginName] = function(options) {
    var method = false,
      methodArgs = arguments;

    if (typeof options == 'string') {
      method = options;
    }

    return this.each(function() {
      var plugin = $.data(this, namespace);

      if (!plugin && !method) {
        $.data(this, namespace, new Plugin(this, options));
      } else if (method) {
        callMethod(plugin, method, Array.prototype.slice.call(methodArgs, 1));
      }
    });
  };
}(jQuery));

/**
 * Plugin to handle the Drawer Slideouts
 */

(function($) {

  'use strict';

  var pluginName = 'drawerFS',
    namespace = 'plugin_' + pluginName;


      /**
       * The Plugin constructor
       * @constructor
       * @param {HTMLElement} element The element that will be monitored
       * @param {Object} options
       */
      function Plugin(element, options) {
        this.element = $(element);

        this._init(options);
      }

      Plugin.prototype._init = function(options) {
        var self = this;
        if(options['type'] != undefined){
          this.drawerType = options['type'];
        }else{
          this.drawerType = this.element.data('type');
        }
        this.mainEl = $('#main');
        this.activeDrawer = '';
        this.openAutomatic = (options['openAutomatic'] ? true : false);

        var elToggle ='';
        //
        if(this.openAutomatic)
        {
          self._buildGenericDrawer(this.element);
        }else{
          //
          this.element.on("click", function(e)
          {
            switch(self.drawerType) {
              case 'set-info':
                elToggle = $(this).data('for');
                self._buildSetDrawer(elToggle);
                break;
              case 'ingredients':
              elToggle = $(this).attr('href');
              self._buildIngredDrawer(elToggle);
                break;
              default:
              elToggle = $(this).attr('href');
              self._buildGenericDrawer(elToggle);
            }
          });
        }

      };

  Plugin.prototype.destroy = function() {
    this.activeDrawer.find('close-action').off('click');
    //this.pageOverlay.off('click');
  };

  Plugin.prototype._buildSetDrawer = function(targetContent) {
    var self = this;
    if($('#pdp-drawer').length > 0){
      this.activeDrawer = $('#pdp-drawer');
      this.activeDrawer.html('');
    }else{
      this.activeDrawer = $("<div>", {id: "pdp-drawer", "class": "pdp-content"});
    }

    var setItem = $("<div>", {"class": "product-set-item container"});
    var setInfo = $("<div>", {"class": "product-set__info row"});

    this.activeDrawer.append(this._buildControls(false));

    setInfo.html($('#'+targetContent).html());
    setItem.html(setInfo);
    this.activeDrawer.append(setItem);
    //
    this.activeDrawer.css('left',($(window).width() * -1)+'px');
    //this.activeDrawer.addClass('active');
    //
    $(this.activeDrawer).insertAfter(this.mainEl);
    $('body').addClass('no-scroll');

    this.activeDrawer.find('.close-action').on('click', $.proxy(this._closeDrawer, this));
    setTimeout(function() {self.activeDrawer.addClass('active');}, 100);
    $(document).trigger('set-drawer-open');
  };

  Plugin.prototype._buildIngredDrawer = function(targetContent) {
    var self = this;
    if($('#ingredients-drawer').length > 0){
      this.activeDrawer = $('#ingredients-drawer');
      this.activeDrawer.html('');
    }else{
      this.activeDrawer = $("<div>", {id: "ingredients-drawer", "class": "pdp-content drawer"})
    }

    var container = $("<div>", {"class": "content-container"});

    this.activeDrawer.append(this._buildControls(true));

    container.html($(targetContent).html());
    this.activeDrawer.append(container);
    //
    $(this.activeDrawer).insertAfter(this.mainEl);
    this.activeDrawer.find('.close-action').on('click', $.proxy(this._closeDrawer, this));
    $('body').addClass('no-scroll');
    $('.page__overlay').addClass('page__overlay--open');
    $('.page__overlay').on('click', function(){
      self.activeDrawer.find('.close-action').trigger('click');
    });
    setTimeout(function() {self.activeDrawer.addClass('active');}, 100);
  };

  Plugin.prototype._buildGenericDrawer = function(targetContent) {
    var self = this;
    if($('#generic-drawer').length > 0){
      this.activeDrawer = $('#generic-drawer');
      this.activeDrawer.html('');
    }else{
      this.activeDrawer = $("<div>", {id: "generic-drawer", "class": " drawer"})
    }

    var container = $("<div>", {"class": "content-container"});

    this.activeDrawer.append(this._buildControls(true));

    container.html($(targetContent).html());
    this.activeDrawer.append(container);
    //
    $(this.activeDrawer).insertAfter(this.mainEl);
    this.activeDrawer.find('.close-action').on('click', $.proxy(this._closeDrawer, this));
    $('body').addClass('no-scroll');
    $('.page__overlay').addClass('page__overlay--open');
    $('.page__overlay').on('click', function(){self.activeDrawer.find('.close-action').trigger('click');});
    setTimeout(function() {self.activeDrawer.addClass('active');}, 100);
  };

  Plugin.prototype._buildControls = function(useX) {

    if(useX){
      var closeAction = $("<div>", { "class": "close-action"});
      closeAction.html('&nbsp;');
    }else{
      var closeAction = $("<div>", { "class": "close-action"});
      var closeTitle = $("<span>", {"class": "close-info"});
      closeTitle.html('CLOSE');
      closeAction.append(closeTitle);
    }


    return closeAction
  }

  Plugin.prototype._closeDrawer = function(event) {
    var self = this;
    switch(self.drawerType) {
      case 'ingredients':
        this.activeDrawer.removeClass('active');
        if (Modernizr.mq('(min-width: 1080px)')) {
          $('body').removeClass('no-scroll');
        }
        $('.page__overlay').removeClass('page__overlay--open');
        $('.page__overlay').off('click');

        break;
      default:
        this.activeDrawer.removeClass('active');
        $('body').removeClass('no-scroll');
        $('.page__overlay').removeClass('page__overlay--open');
        $('.page__overlay').off('click');
    }

    //setTimeout(function() {self.activeDrawer.remove();}, 1000);

    event.preventDefault();
  };

  $.fn[pluginName] = function(options) {
    var method = false,
      methodArgs = arguments;

    if (typeof options == 'string') {
      method = options;
    }

    return this.each(function() {
      var plugin = $.data(this, namespace);

      if (!plugin && !method) {
        $.data(this, namespace, new Plugin(this, options));
      } else if (method) {
        callMethod(plugin, method, Array.prototype.slice.call(methodArgs, 1));
      }
    });
  };
}(jQuery));
//end drawer plugin



//
//Glossary
//

(function($) {

  'use strict';

  var pluginName = 'glossaryFS',
    namespace = 'plugin_' + pluginName;


      /**
       * The Plugin constructor
       * @constructor
       * @param {HTMLElement} element The element that will be monitored
       * @param {Object} options
       */
      function Plugin(element, options) {
        this.element = $(element);

        this._init(options);
        this.glossaryData = {};
        this.updatedTerms = {}
        this.useUpdatedTerms = false;
        
      }

      Plugin.prototype._init = function(options) {
        var self = this;
        if(options['type'] != undefined){
          this.type = options['type'];
        }else{
          this.type = '';
        }
        self._getGlossaryData();
        //this.mainEl = $('#main');
        //this.activeDrawer = '';
        //this.openAutomatic = (options['openAutomatic'] ? true : false);
      };

      Plugin.prototype.update = function(data) {
        this.useUpdatedTerms = true;
        this.updatedTerms = JSON.parse('['+data+']');
      };

      Plugin.prototype._getGlossaryData = function() {
        //var glossaryData = '';
        var _self = this;

        $.ajax('/pages/glossary?requestType=ajax').then(function(result) {
          var domResult = $(result);
          var cleanJsonString = _self._removeLastComma(domResult.find('#glossary-data-raw').html());
          _self.glossaryData = JSON.parse('['+cleanJsonString+']');

          _self._linkTerms(_self.glossaryData);
          //
          $('a[data-term]').drawerFS({
            type: 'glossary'
          });
        });
      }

      Plugin.prototype._buildTermMarkup = function(termObj) {
        var _self = this;
        var cleanName = termObj.term.replace(/ /g, "-");
        var termEl = $('#'+cleanName);
        if(termEl.length < 1){
          termEl = $("<div>", {id: cleanName, "class": "d-none"})
        }
        var title = $("<h2>", {"class": "text-uppercase text-left"});
        var container = $("<div>", {"class": "full-content"});
        //
        title.html(termObj.term);
        container.html(termObj.definition);
        //
        termEl.append(title);
        termEl.append(container);
        termEl.insertAfter(_self.element);
      };

      Plugin.prototype._linkTerms  = function(jsonData) {
        var _self = this;
        jQuery.each(jsonData, function(key, val) {
          //console.log(val.term);
           _self._buildTermMarkup(val);
          $('main p, .product-details li, .primary-copy li').each(function(){
            var self = $(this);
            var content = self.html();
            var extraClass="";
            if(val.italic){
              extraClass="font-italic";
            }

            if(content.search(val.term) > -1){
              var cleanName = val.term.replace(/ /g, "-");
              var gtmExtra = "onclick=\"dataLayer.push({'event': 'term-drawer','term': '"+val.term+"'});\"";

              var newContent = content.replace(val.term,'<a href="#'+cleanName+'" data-term class="'+extraClass+'" '+gtmExtra+'>'+val.term+'</a>');
              self.html(newContent);
            }
          });
        });

        if(_self.useUpdatedTerms){
          _self.updatedTerms.forEach((gItem) => {
            const cleanTermName = gItem.term.replace(/ /g, "-");
            $('#'+cleanTermName+' .full-content p').html(gItem.definition);
          });
        }
      }

      Plugin.prototype._removeLastComma  = function(strng) {
          var n=strng.lastIndexOf(",");
          var a=strng.substring(0,n)
          return a;
      }

      $.fn[pluginName] = function(options) {
        var method = false,
          methodArgs = arguments;

        if (typeof options == 'string') {
          method = options;
        }

        return this.each(function() {
          var plugin = $.data(this, namespace);

          if (!plugin && !method) {
            $.data(this, namespace, new Plugin(this, options));
          } else if (method) {
            callMethod(plugin, method, Array.prototype.slice.call(methodArgs, 1));
          }
        });
      };
}(jQuery));
//end glossary plugin



//
//Blog Ajax
//

(function($) {

  'use strict';

  var pluginName = 'blogAjaxFS',
    namespace = 'plugin_' + pluginName;


      /**
       * The Plugin constructor
       * @constructor
       * @param {HTMLElement} element The element that will be monitored
       * @param {Object} options
       */
      function Plugin(element, options) {
        this.element = $(element);

        this._init(options);
      }

      Plugin.prototype._init = function(options) {
        var self = this;
        if(options['type'] != undefined){
          this.type = options['type'];
        }else{
          this.type = '';
        }

        this.totalPosts = this.element.data('items');
        this.pageSize = this.element.data('size');

        this.element.on('click', function(e){
          e.preventDefault();
          var hrefPath = new URL('https://'+window.location.hostname+$(this).attr('href'));
          var urlParams = new URLSearchParams(hrefPath.search);
          var pageNum = urlParams.get('page');
          var newPath = '';
          var totalPosts = $(this).data('items');
          var pageSize = $(this).data('size');
          //
          self._getNextPage(hrefPath.pathname + "?"+ urlParams.toString());
          //
          pageNum++;
          urlParams.set('page', pageNum);
          newPath = hrefPath.pathname + "?"+ urlParams.toString();
          $(this).attr('href',newPath);
          //
          if((pageNum*pageSize) > totalPosts){
            $(this).hide();
          }

        });

      };

      Plugin.prototype._getNextPage = function(path) {
        var self = this;

        // Then we add the product in Ajax
        $.ajax(path).then(function(result) {
          var resultHtml = $(result).find('#blog-primary-content').html();
          if(resultHtml.length > 100){
            $('#blog-primary-content').append(resultHtml);
            //self.element.attr("disable","");
          }else{
            self.element.hide();
            $("#end-post-message").removeClass('d-none');
          }
        });
        //
        event.preventDefault();
      };


      $.fn[pluginName] = function(options) {
        var method = false,
          methodArgs = arguments;

        if (typeof options == 'string') {
          method = options;
        }

        return this.each(function() {
          var plugin = $.data(this, namespace);

          if (!plugin && !method) {
            $.data(this, namespace, new Plugin(this, options));
          } else if (method) {
            callMethod(plugin, method, Array.prototype.slice.call(methodArgs, 1));
          }
        });
      };
}(jQuery));
//end blog ajax plugin

//
//Collection Ajax
//

(function($) {

  'use strict';

  var pluginName = 'collectionAjaxFS',
    namespace = 'plugin_' + pluginName;


      /**
       * The Plugin constructor
       * @constructor
       * @param {HTMLElement} element The element that will be monitored
       * @param {Object} options
       */
      function Plugin(element, options) {
        this.productContainer = $(element);

        this._init(options);
      }

      Plugin.prototype._init = function(options) {
        let self = this;
        if(options['type'] != undefined){
          this.type = options['type'];
        }else{
          this.type = '';
        }
        self.currentPage = 1;
        self.isLoading = false;
        self.containerEndPos = self.productContainer.outerHeight() + self.productContainer.offset().top;
        self.loadLine = (self.containerEndPos / 4) * 2;
        self.onLastPage = false;
        //self.loadLine = ($( window ).height() / 4) * 3;

        $( window ).scroll(function() {
          //console.log($( window ).scrollTop());
          if($( window ).scrollTop() >= self.loadLine && !self.isLoading && !self.onLastPage){
            self._checkPage();
          }
        });

      };

      Plugin.prototype._checkPage = function() {
        let self = this;
        self.isLoading = true;
        let winLocation = new URL(window.location);
        let urlParams = new URLSearchParams(winLocation);
        //var pageNum = urlParams.get('page');
        if(self.currentPage == 1){
          if(urlParams.has('page')){
            self.currentPage = urlParams.get('page');
          }else{
            self.currentPage = 1;
          }
        }

        //increment page
        self.currentPage++;
        urlParams.set('page',self.currentPage);
        urlParams.set('view','ajax');
        self._getNextPage(window.location + "?"+ urlParams.toString());

      };

      Plugin.prototype._getNextPage = function(path) {
        var self = this;
        console.log(path)
        // Then we add the product in Ajax
        $.ajax({
          url: path,
          type: "GET",
          dataType: "html",
          succes: function(data){
             // Example: alert(data);
             // Do whatever you want with the returned data using JS or jQuery methods
          }
        }).then(function(result) {
          self.containerEndPos = self.productContainer.outerHeight() + self.productContainer.offset().top;
          self.loadLine = (self.containerEndPos / 4) * 2;
          self.isLoading = false;

          var resultHtml = $(result).find('#'+self.productContainer.attr('id')).html();
          if(resultHtml.length > 100){
            self.productContainer.append(resultHtml);
            //self.element.attr("disable","");
          }else{
            self.onLastPage = true;
          }
        });
        //
        event.preventDefault();
      };


      $.fn[pluginName] = function(options) {
        var method = false,
          methodArgs = arguments;

        if (typeof options == 'string') {
          method = options;
        }

        return this.each(function() {
          var plugin = $.data(this, namespace);

          if (!plugin && !method) {
            $.data(this, namespace, new Plugin(this, options));
          } else if (method) {
            callMethod(plugin, method, Array.prototype.slice.call(methodArgs, 1));
          }
        });
      };
}(jQuery));
//end collection ajax plugin

//
//Cart Helper
//

(function($) {

  'use strict';

  var pluginName = 'CartHelperFS',
    namespace = 'plugin_' + pluginName;


      /**
       * The Plugin constructor
       * @constructor
       * @param {HTMLElement} element The element that will be monitored
       * @param {Object} options
       */
      function Plugin(element, options) {
        this.element = $(element);

        this._init(options);
      }

      Plugin.prototype._init = function(options)
      {
        var self = this;
        self.giftProductInCart = false;
        self.giftCode = options['giftCode'];
        self.giftProductID = (options['giftProductID'] * 1);
        self.bundleSku = 'F052-01-BND0';
        self.cloverlyProductID = (options['cloverlyProductID'] * 1);
        self.samplesList = options['samplesList'].split(',').map(iNum => parseInt(iNum, 10));
        self.samplesLimit = options['samplesLimit'];
        self.cartItemsBC = [];
        self.cartTotalTriggerGift = options['cartTotalTriggerGift'];
        self.cartProductsTriggerGift = (options['cartProductsTriggerGift'] != '') ? options['cartProductsTriggerGift'].split(',').map(iNum => parseInt(iNum, 10)) : [];
        self.cartTotalTriggerSamples = (options['cartTotalTriggerSamples'] * 1);
        self.pointsMultiplier = options['pointsMultiplier'];
        self.autoApplyAttempts = 0;
        self.autoCloverlyCheck = 0;
        self.cartWeight = 0;
        self.giftBoxes =[39624159690787,39624159723555,39624159756323];
        self.isGiftWrapInCart = false;
        self.giftwrapSwitch = $('.giftwrap .switch-item');

        if(self.samplesList.length > 1)
        {
          $('.product-item-mini.sample .product__add-to-cart').click(function() {
            $(this).parents('.sample').addClass('added-to-cart');
          });
        }
        //
        //
        //
        $(document).on('cart.ready', function(event, cart) {
            self._checkSamplesInCart(cart);
            self._checkCloverlyInCart(cart);
            self._checkPromoTriggersInCart(cart);
            self._checkWeightInCart(cart);
            self._updateDeliveryInstructions();
            //self._checkCartTotals(cart);
        });
        $(document).on('cart.requestStarted', function(event, cart) {
          //console.log('cart.requestStarted');
          self.cartItemsBC = cart.items;
        });

        $(document).on('cart.requestComplete', function(event, cart) {
            //console.log('cart.requestComplete');
            self._checkSamplesInCart(cart);
            self._checkCloverlyInCart(cart);
            self._checkPromoTriggersInCart(cart);
            self._checkWeightInCart(cart);
            self._checkCartTotals(cart);
            self._updateDeliveryInstructions();
        });

        window.addEventListener("sc:discount.update", function (event) {
          //console.log("sc:discount.update");
          var discountData = JSON.parse(sessionStorage.scDiscountData) || {};
          if(discountData['discount'] == null && discountData['error'] != null){
            self._checkCartTotals(JSON.parse(sessionStorage.scCartData) || {});
          }
        },false);

        window.addEventListener("sc:discount.calculated", function (event) {
          //console.log("sc:discount.calculated");
          //console.log(JSON.parse(sessionStorage.scCartData));
          self._checkCartTotals(JSON.parse(sessionStorage.scCartData) || {});

        },false);

        window.addEventListener("sc:discount.remove", function (event) {
          //console.log("sc:discount.remove");
          self._setCookie('forefitGift',self.giftProductID,3);
          self._checkCartTotals(JSON.parse(sessionStorage.scCartData) || {});
        },false);

        window.addEventListener("sc:discount.init", function (event) {
          //console.log("testInit: sc:discount.init");
          self._checkCartTotals(JSON.parse(sessionStorage.scCartData) || {});
        },false);

        window.addEventListener("DOMContentLoaded", function (event) {
          //console.log("DOMContentLoaded");
          self._checkCloverlyInit();
        },false);

        $('#gift_message').bind('focusout', function() {
          self._updateDeliveryInstructions();
        });

        self.giftwrapSwitch.bind('input propertychange', function() {
          $(".giftwrap .gw-container").toggleClass('d-none');

          if(!$('.giftwrap .switch-item input').prop('checked')){
            $('#gift_message').html("");
            _.each(self.giftBoxes, function(variant_id){
              CartJS.removeItemById(variant_id);
            });
          }
        });

      };

      Plugin.prototype._setCookie = function(cname, cvalue, exdays)
      {
        var d = new Date();
        d.setTime(d.getTime() + (exdays*24*60*60*1000));
        var expires = "expires="+ d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
      };

      Plugin.prototype._getCookie = function(cname)
      {
        var name = cname + "=";
        var ca = document.cookie.split(';');
        for(var i = 0; i < ca.length; i++) {
          var c = ca[i];
          while (c.charAt(0) == ' ') {
            c = c.substring(1);
          }
          if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
          }
        }
        return "";
      };

      Plugin.prototype._checkSamplesInCart = function(cart)
      {
        let self = this;
        if(self.samplesList.length >= 1)
        {
          //UI Update
          $('.product-item-mini.sample').removeClass('added-to-cart');

          let samplesInCart = _.filter(cart.items, function(item){
            if(_.indexOf(self.samplesList, item['variant_id']) > -1)
            {
              //UI Update
              $('.product-item-mini.sample[data-variant-id="'+item['variant_id']+'"]').addClass('added-to-cart');

              return item['variant_id']
            }
          });

          //
          if(self.samplesLimit == samplesInCart.length){
            $('.product-item-mini.sample .product__add-to-cart').attr('disabled','disabled');
          }else{
            $('.product-item-mini.sample .product__add-to-cart').removeAttr('disabled','disabled');
          }
        }

      };

      Plugin.prototype._checkPromoTriggersInCart = function(cart)
      {
        let self = this;

        if(self.cartProductsTriggerGift.length >= 1)
        {
          //UI Update
          //$('.product-item-mini.sample').removeClass('added-to-cart');

          let productTriggersInCart = _.filter(cart.items, function(item){
            if(_.indexOf(self.cartProductsTriggerGift, item['variant_id']) > -1)
            {
              return item['variant_id']
            }
          });

          if(productTriggersInCart.length >= 1){
            $('.cart-item.promotional').removeClass('d-none');
            self._addGiftInCart(cart);
          }else{
            $('.cart-item.promotional').addClass('d-none');
          }
        }else if(self.cartTotalTriggerGift > 1){
          $('.cart-item.promotional').removeClass('d-none');
        }

      };

      Plugin.prototype._checkWeightInCart = function(cart)
      {
        let self = this;
        let lineWeight = 0;
        self.cartWeight = 0;

        _.each(cart.items, function(item){
          lineWeight = item.quantity * item.grams;
          self.cartWeight += lineWeight;
        });

        let giftWrapInCart = _.filter(cart.items, function(item){
          if(_.indexOf(self.giftBoxes, item['variant_id']) > -1)
          {
            return item;
          }
        });

        //UI
        $('.giftwrap .gift-box-price').addClass('d-none');
        $('.giftwrap .gift-box-add').addClass('d-none');
        $('.giftwrap .gift-box-added').addClass('d-none');

        if(giftWrapInCart.length < 1){
          self.isGiftWrapInCart = false;
          if(self.cartWeight >= 0 && self.cartWeight <= 278)
          {
            $('.giftwrap .gift-box-price[data-sku="F060-01-0000"]').removeClass('d-none');
            $('.giftwrap .gift-box-add[data-sku="F060-01-0000"]').removeClass('d-none');
          }else if(self.cartWeight >= 279 && self.cartWeight <= 1069)
          {
            $('.giftwrap .gift-box-price[data-sku="F060-02-0000"]').removeClass('d-none');
            $('.giftwrap .gift-box-add[data-sku="F060-02-0000"]').removeClass('d-none');
          }else if(self.cartWeight >= 1070)
          {
            $('.giftwrap .gift-box-price[data-sku="F060-03-0000"]').removeClass('d-none');
            $('.giftwrap .gift-box-add[data-sku="F060-03-0000"]').removeClass('d-none');
          }
        }else{
          self.isGiftWrapInCart = true;
          $('.giftwrap .gift-box-added').removeClass('d-none');
          $('.giftwrap .gift-box-add').addClass('d-none');

          self._giftWrapWeightCheck(self.cartWeight,giftWrapInCart)
        }
      };

      Plugin.prototype._giftWrapWeightCheck = function(cartWeight,giftWrapInCart)
      {
        let wrapSwapOut = 0;
        //[39624159690787,39624159723555,39624159756323];
        //console.log("cartWeight: "+cartWeight);
        //console.log("wrap sku: "+giftWrapInCart[0].sku);
        switch(giftWrapInCart[0].sku) {
          case "F060-01-0000":
            if(cartWeight >= 279 && cartWeight <= 1069)
            {
              wrapSwapout = 39624159723555;
            }else if(cartWeight >= 1070)
            {
              wrapSwapout = 39624159756323;
            }
            break;
          case "F060-02-0000":
            if(cartWeight >= 0 && cartWeight <= 278)
            {
              wrapSwapOut = 39624159690787;
            }else if(cartWeight >= 1070)
            {
              wrapSwapOut = 39624159756323;
            }
            break;
          case "F060-03-0000":
          //console.log("qty: "+giftWrapInCart[0].quantity);
            if(cartWeight >= 0 && cartWeight <= 278)
            {
              wrapSwapOut = 39624159690787;
            }else if(cartWeight >= 279 && cartWeight <= 1069)
            {
              wrapSwapOut = 39624159723555;
            }
            break;
          default:
            // code block
        }
        if(wrapSwapOut){
          //console.log("update 3");
          //console.log("wrapSwapOut: "+wrapSwapOut);
          //console.log("old wrapSku: "+giftWrapInCart[0].variant_id);
          CartJS.addItem(wrapSwapOut, 1);
          CartJS.removeItemById(giftWrapInCart[0].variant_id);
        }
      }

      Plugin.prototype._checkCloverlyInCart = function(cart)
      {
        var self = this;
        if(self.cloverlyProductID > 1)
        {
          var isCloverlyCart = _.where(cart.items, {variant_id: self.cloverlyProductID});
          //UI Update
          if(isCloverlyCart.length >= 1){
            $('.cloverly-fs').addClass('added-to-cart');
              $('.cloverly-green-shipping-button').prop( "checked", true );
          }else{
            $('.cloverly-fs').removeClass('added-to-cart');
              $('.cloverly-green-shipping-button').prop( "checked", false );
          }
        }

      };

      Plugin.prototype._checkCloverlyInit = function()
      {
        var self = this;
        if(self.cloverlyProductID != '')
        {
          if(window.Cloverly == undefined && self.autoCloverlyCheck <= 5)
          {
              //console.log('no Cloverly data!');
              self.autoCloverlyCheck++
              self.element.data('timeout_c', setTimeout($.proxy(self._checkCloverlyInit, self), 2000));
          }else if(window.Cloverly != undefined)
          {
            if(window.Cloverly.estimate == undefined && self.autoCloverlyCheck <= 5)
            {
              //console.log('no estimate data!');
              self.autoCloverlyCheck++
              self.element.data('timeout_c', setTimeout($.proxy(self._checkCloverlyInit, self), 2000));
            }else if(window.Cloverly.estimate != undefined)
            {
              clearTimeout(self.element.data('timeout_c'));
              $('.cloverly-fs').removeClass('d-none');
              $('.cloverly-link').attr('href',window.Cloverly.estimate.pretty_url+'?ref=shopify')

              /* if(!$('.cloverly-green-shipping-button').prop('checked')){
                $('.cloverly-green-shipping-button').trigger('click');
              }*/
            }else{
              clearTimeout(self.element.data('timeout_c'));
            }
          }
        }
      };

      Plugin.prototype._removeSamplesInCart = function(cart)
      {
        var self = this;
        if(self.samplesList.length > 1)
        {
          var samplesInCart = _.filter(cart.items, function(item){
            if(_.indexOf(self.samplesList, item['variant_id']) > -1)
            {
              CartJS.removeItemById(item['variant_id']);
            }
          });
        }
      };

      Plugin.prototype._handleGiftCode = function()
      {
        var self = this;
        var discountData = JSON.parse(sessionStorage.scDiscountData) || {};
        if(discountData['discount'] == null && self.autoApplyAttempts <= 5)
        {
          if(self.giftCode != ''){
            //console.log('apply code!');
            self.autoApplyAttempts++
            window.DiscountHero.discount.apply(self.giftCode);
            self.element.data('timeout', setTimeout($.proxy(self._handleGiftCode, self), 1000));
          }

        }else{
          clearTimeout(self.element.data('timeout'));
        }
      };

      Plugin.prototype._addGiftInCart = function(cart)
      {
        var self = this;

        if(self.giftProductID >1)
        {
          var giftInCart = _.where(cart.items, {variant_id: self.giftProductID});

          if(giftInCart.length >= 1)
          {
            //console.log('gift: '+self.giftProductID+' in cart');
            if(self._getCookie('forefitGift') != self.giftProductID)
            {
              self._handleGiftCode();
            }
          }else
          {
            //console.log('gift: '+self.giftProductID+' is NOT in cart');

            if(self.cartItemsBC.length >= 1)
            {
              var wasinCart = _.where(self.cartItemsBC, {variant_id: self.giftProductID});
              //console.log(wasinCart);
              if( wasinCart.length >= 1)
              {
                //console.log('gift must have been removed by customer: ');
                self._setCookie('forefitGift',self.giftProductID,3);
              }else{
                //console.log("found nothing...");
              }
            }else{
              //console.log('empty cartItemsBC');
              if(self._getCookie('forefitGift') != self.giftProductID)
              {
                  CartJS.addItem(self.giftProductID);
              }
            }

          }
        }else{
          //console.log('no gift product id found');
        }
      };

      Plugin.prototype._updateGiftPromoDispaly = function(cart,subtotal)
      {
        var self = this;
        //console.log("_updateGiftPromoDispaly promoID: "+self.giftProductID+" TriggerTotal: "+self.cartTotalTriggerGift);
        if(self.giftProductID != '' && self.cartTotalTriggerGift !== 0)
        {
          let differenceAmountNum = self.cartTotalTriggerGift - subtotal;
          let differenceAmountPercent =subtotal / self.cartTotalTriggerGift;
          //
          //console.log("diffAmmount: "+differenceAmountNum);
          //console.log("diffPercent: "+differenceAmountPercent);
          if(differenceAmountNum > 0)
          {
            let cleanDiffAmount = +(differenceAmountNum).toFixed(2);
            $('.cart-item.promotional .difference-ammount').html('$'+cleanDiffAmount);
            $('.cart-item.promotional .progress-info .meter').css('width',(differenceAmountPercent*100)+'%');
            $('.cart-item.promotional .action-needed').removeClass('d-none');
            $('.cart-item.promotional .action-auto').addClass('d-none');
            $('.cart-item.promotional .action-redeem').addClass('d-none');
          }else
          {
            $('.cart-item.promotional .progress-info .meter').css('width','100%');
            if(self._getCookie('forefitGift') != self.giftProductID)
            {
              $('.cart-item.promotional .action-needed').addClass('d-none');
              $('.cart-item.promotional .action-auto').removeClass('d-none');
              $('.cart-item.promotional .action-redeem').addClass('d-none');
            }else{
              $('.cart-item.promotional .action-auto').addClass('d-none');
              $('.cart-item.promotional .action-needed').addClass('d-none');
              $('.cart-item.promotional .action-redeem').removeClass('d-none');
            }
          }
        } else if(self.giftProductID != '' && self.cartProductsTriggerGift.length >= 1)
        {

          if(self._getCookie('forefitGift') != self.giftProductID)
          {
            $('.cart-item.promotional .action-needed').addClass('d-none');

            $('.cart-item.promotional .action-redeem').addClass('d-none');
          }else{
            let giftInCart = _.where(cart.items, {variant_id: self.giftProductID});
            if(giftInCart.length >= 1)
            {
              $('.cart-item.promotional .action-auto').removeClass('d-none');
              $('.cart-item.promotional .action-needed').addClass('d-none');
              $('.cart-item.promotional .action-redeem').addClass('d-none');
            }else{
              $('.cart-item.promotional .action-auto').addClass('d-none');
              $('.cart-item.promotional .action-needed').addClass('d-none');
              $('.cart-item.promotional .action-redeem').removeClass('d-none');
            }
          }
        }
      };

      Plugin.prototype._updateGiftPriceDisplay = function(cart,discountData)
      {
        var self = this;
        if(self.giftProductID > 1)
        {
          var giftInCart = _.where(cart.items, {variant_id: self.giftProductID});

          if(giftInCart.length >= 1)
          {
            $('.cart-item.promotional .action-needed').addClass('d-none');
            $('.cart-item.promotional .action-auto').removeClass('d-none');
            $('.cart-item.promotional .action-redeem').addClass('d-none');

            if(discountData['discount'] == null)
            {
                $('.cart-item[data-variant-id="'+self.giftProductID+'"] .product-item__price').removeClass('d-none');
                $('.cart-item[data-variant-id="'+self.giftProductID+'"] .product-item__price.no-cost').addClass('d-none');
            }else if(giftInCart[0]['quantity'] > 1){
              var newDisplayPrice = (giftInCart[0]['line_price'] -giftInCart[0]['original_price'])/100;
                $('.cart-item[data-variant-id="'+self.giftProductID+'"] .product-item__price.line-price').html("$"+newDisplayPrice);
                $('.cart-item[data-variant-id="'+self.giftProductID+'"] .product-item__price').removeClass('d-none');
                $('.cart-item[data-variant-id="'+self.giftProductID+'"] .product-item__price.no-cost').addClass('d-none');
            }else{
                $('.cart-item[data-variant-id="'+self.giftProductID+'"] .product-item__price').addClass('d-none');
                $('.cart-item[data-variant-id="'+self.giftProductID+'"] .product-item__price.no-cost').removeClass('d-none');
            }
          }
        }
      };

      Plugin.prototype._updateDisplayTotals = function(subtotal, discountData)
      {
        var self = this;

        if(discountData['discount'] == null)
        {
          //var cleanSubtotal = +(subtotal).toFixed(2);
          let cleanSubtotal = Shopify.formatMoney(subtotal);
          var parts = cleanSubtotal.split('.');
          if(parts[1] === '00'){
            cleanSubtotal = parts[0];
          }
          let loyaltyPoints = Math.floor((subtotal/100)*self.pointsMultiplier);
          $('.discountTotal').addClass('d-none');
          $('.subtotal .cart_total-price').html(cleanSubtotal);
          $('.orderTotal .cart_total-price').html(cleanSubtotal);
          $('.loyalty-points .cart_total-price').html(loyaltyPoints);
          if(self.giftProductID > 1)
          {
            $('.cart-item[data-variant-id="'+self.giftProductID+'"] .product-item__price').removeClass('d-none');
            $('.cart-item[data-variant-id="'+self.giftProductID+'"] .product-item__price.no-cost').addClass('d-none');
          }

        }else{
          var cleanOrderTotal = +((discountData['subtotal']*1));
          var loyaltyPoints = Math.floor(cleanOrderTotal*self.pointsMultiplier);
          $('.discountTotal .cart_total-price').html('-$'+ discountData['discount']['amount']);
          $('.subtotal .cart_total-price').html('$'+ discountData['total']);
          $('.orderTotal .cart_total-price').html('$'+ discountData['subtotal']);
          $('.loyalty-points .cart_total-price').html(loyaltyPoints);
          $('.discountTotal').removeClass('d-none');
          if(self.giftProductID > 1)
          {
            $('.cart-item[data-variant-id="'+self.giftProductID+'"] .product-item__price').addClass('d-none');
            $('.cart-item[data-variant-id="'+self.giftProductID+'"] .product-item__price.no-cost').removeClass('d-none');
          }
        }
      };

      Plugin.prototype._checkCartTotals = function(cart)
      {
        var self = this;
        if(sessionStorage.scDiscountData){
          var discountData = JSON.parse(sessionStorage.scDiscountData) || {};
        }else{
          var discountData = {};
        }

        if(discountData['subtotal']){
          //console.log('use discount subtotal');
          var formattedSubtotal = (discountData['subtotal']*1);
          self._updateDisplayTotals(formattedSubtotal,discountData);
        }else{
          //console.log('use cart subtotal');
          var formattedSubtotal = cart['items_subtotal_price']/100;
          self._updateDisplayTotals(cart['items_subtotal_price'],discountData);
        }
        //samples cart check
        if(formattedSubtotal < self.cartTotalTriggerSamples){
          $('.cart-samples').addClass('no-access');
          self._removeSamplesInCart(cart);
        }else{
          $('.cart-samples').removeClass('no-access');
        }
        //gift promo cart check

        if(self.cartTotalTriggerGift !== 0 && formattedSubtotal >= self.cartTotalTriggerGift ){
          self._addGiftInCart(cart);
        }
        self._updateGiftPriceDisplay(cart,discountData);
        self._updateGiftPromoDispaly(cart,formattedSubtotal);

      };

      Plugin.prototype._updateDeliveryInstructions = function()
      {
        var self = this;
        var cartItems = CartJS.cart.items;
        //var noteParts = CartJS.getNote().split('-----');
        var noteParts = $("#note").html().split('-----');
        var giftMessage =  $('#gift_message').val().trim();
        var formatedMessage = '';
        var bundleInfo = '';
        //console.log(noteParts);
        if(self.isGiftWrapInCart){
          if(noteParts.length > 1)
          {
            let messageClean = noteParts[1].replace(/Gift Message:\n/gi, "");

            $('#gift_message').html(messageClean);
            giftMessage =  $('#gift_message').val().trim();
            $('.giftwrap .switch-item input').prop('checked', true);
            $(".giftwrap .gw-container").removeClass('d-none');
          }

          if(giftMessage != "")
          {
            formatedMessage += "\n"+"-----\n" + "Gift Message:\n"+giftMessage;
            $('.giftwrap .gift-box-add').prop('disabled', false);
          }else{
            $('.giftwrap .gift-box-add').prop('disabled', true);
          }
        }else{
          if(giftMessage != ""){
            $('.giftwrap .gift-box-add:not(.d-none)').trigger('click');
          }
        }


        if(cartItems.length)
        {
          var bundleProducts = _.where(cartItems, {sku: self.bundleSku});
          if(bundleProducts.length >= 1)
          {
            //product_title
            bundleInfo += "Custom Sets\n";
            _.each(bundleProducts, function(item)
            {
              bundleInfo += item.product_title+" "+self.bundleSku+ ":\n";
              _.each(item.properties, function(prop)
              {
                let propParts = prop.split('[');
                bundleInfo += '['+propParts[1]+ ",";;
              });
              bundleInfo += "\n";
            });
          }else{
            bundleInfo = '';
          }
        }

        //CartJS.setNote(formatedMessage+bundleInfo);
        let completeNotes = bundleInfo+formatedMessage;
        if($("#note").html() != completeNotes){
          CartJS.setNote(completeNotes);
          $("#note").html(completeNotes);
          //console.log("notes updated!");
        }
        /*
        if(self.isGiftWrapInCart){
          $("#note").html(bundleInfo+formatedMessage);
        }else{
          $("#note").html(bundleInfo);
        }
        */

      };

      $.fn[pluginName] = function(options) {
        var method = false,
          methodArgs = arguments;

        if (typeof options == 'string') {
          method = options;
        }

        return this.each(function() {
          var plugin = $.data(this, namespace);

          if (!plugin && !method) {
            $.data(this, namespace, new Plugin(this, options));
          } else if (method) {
            callMethod(plugin, method, Array.prototype.slice.call(methodArgs, 1));
          }
        });
      };
}(jQuery));
//end cart ajax plugin
